
import React from 'react';
import { User, Tenant } from '../types';

export const AuthContext = React.createContext<{
  user: User | null;
  tenant: Tenant | null;
  loading: boolean;
  authError: string | null;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
} | null>(null);
